import { reactPlugin, withAITracking } from "../../../../appInsights";
import { Col, Collapse, Row } from "antd";
import { cloneDeep } from "lodash";
import { useEffect, useMemo, useState } from "react";
import GenericForm from "@components/dynamicForm";
import membersService from "@services/members.service";
import "./supplementalFile.scss";

const { Panel } = Collapse;

const SupplementalFile = (props: any) => {
  const dataCardId = "40";
  const [activeCardPanel, setActiveCardPanel] = useState<any>(props?.activeKey?.includes(dataCardId) ? ["1"] : []);
  const getHeading = (headerValue: string) => <span>{headerValue}</span>;
  const membersServiceGetCurrentMember = membersService?.getCurrentMember;
  const { memberData, isHealthPlanValid, transformedHealthPlanName } = props

  const patientID = useMemo(() => {
    return membersServiceGetCurrentMember?.patient_id;
  }, [membersServiceGetCurrentMember?.patient_id]);

  useEffect(() => {
    setActiveCardPanel(props?.activeKey?.includes(dataCardId) ? ["1"] : []);
  }, [props?.activeKey]);

  const onCollapseChange = () => {
    if (activeCardPanel.length > 0) {
      props?.setActivePanels(cloneDeep(props?.activeKey)?.filter((item: any) => item !== dataCardId));
    } else props?.setActivePanels([...(props?.activeKey ? props?.activeKey : []), dataCardId]);
  };

  useEffect(() => {
    if (memberData?.patientId?.toString() !== patientID?.toString()) {
      setActiveCardPanel([]);
    }
  }, [patientID, memberData?.patientId]);

  return (
    <div className="supplementalWrapper">
      <Collapse
        accordion={true}
        activeKey={activeCardPanel}
        expandIconPosition="right"
        bordered={false}
        onChange={isHealthPlanValid ? onCollapseChange : undefined}
        className={!isHealthPlanValid ? "no-cursor" : ""}
      >
        <Panel header={getHeading("Supplemental Data")} key="1" className="f18 w500" showArrow={isHealthPlanValid}>
          <GenericForm isHealthPlanValid={isHealthPlanValid} transformedHealthPlanName={transformedHealthPlanName} isPanelActive={activeCardPanel.includes("1")} />
        </Panel>
      </Collapse>
    </div>
  );
};

export default withAITracking(reactPlugin, SupplementalFile);
